module.exports = __webpack_public_path__ + "static/media/no_result_found.59d15b3c.gif";